var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShareFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99145,14.19988a3.84319,3.84319,0,1,1,0-4.39976L14.508,7.04187a3.78224,3.78224,0,0,1-.19433-1.19823,3.84953,3.84953,0,1,1,.69493,2.19944L9.493,10.80133a3.81353,3.81353,0,0,1,0,2.39824l5.5156,2.75825a3.83794,3.83794,0,1,1-.50239,1.00031Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFull);
export default __webpack_public_path__ + "static/media/share_full.8bca6f9ce5504b06b503660ad2d85101.svg";
export { ForwardRef as ReactComponent };